import React, { useCallback, useEffect, useRef, useState } from 'react'

// Import State Context
import { useStateContext } from '../../context/StateContextAPI'

import { CompactLogo, RokkApp } from '../../assets'
import DotElement from '../../assets/dot-element.png'
import { NewsletterCard, NewsletterForm } from '../../components'

// Import CSS file
import "./home.page.css"

// Import Material UI Elements
import useGoogleTag from '../../utils/gtag'
import { useTranslation } from 'react-i18next'


// const WebsiteBannerImg = styled.img`
//     width:100%;
// `

const Home = () => {

    // GTAG
    const gtag = process.env.REACT_APP_GOOGLE_TAG || "";
    useGoogleTag(gtag)

    const { t } = useTranslation()

    // Handling Promo Video Playback
    const [playOption, setPlayOption] = React.useState(false);
    const [mute, setMute] = React.useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);
    const handlePlayback = () => {
        setPlayOption(!playOption);
        if (!playOption) videoRef?.current?.pause();
        else videoRef?.current?.play()
    }
    const handleSound = () => {
        setMute(!mute);
    }

    // Timeline checkpoint rotation
    const [activeCheckpoint, setActiveCheckpoint] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const totalCheckpoints = 3;

    const switchCheckpoint = useCallback((next: number) => {
        if (isTransitioning || next === activeCheckpoint) return;
        setIsTransitioning(true);
        setActiveCheckpoint(-1);
        setTimeout(() => {
            setActiveCheckpoint(next);
            setIsTransitioning(false);
        }, 500);
    }, [activeCheckpoint, isTransitioning]);

    useEffect(() => {
        const interval = setInterval(() => {
            const next = (activeCheckpoint === -1 ? 0 : (activeCheckpoint + 1) % totalCheckpoints);
            switchCheckpoint(next);
        }, 5000);
        return () => clearInterval(interval);
    }, [activeCheckpoint, switchCheckpoint]);

    // Set the active page as Home for the Navigation bar
    const { setActivePage } = useStateContext();
    useEffect(() => {
        setActivePage(() => "home")
        window.scrollTo(0, 0);
    }, [setActivePage])

    const newsletterCards = [
        { title: t('newsletterCards.favouriteBands'), content: t('newsletterCards.favouriteBandsDesc') },
        { title: t('newsletterCards.allStyles'), content: t('newsletterCards.allStylesDesc') },
        { title: t('newsletterCards.hifiOffline'), content: t('newsletterCards.hifiOfflineDesc') },
        { title: t('newsletterCards.importFunction'), content: t('newsletterCards.importFunctionDesc') },
    ]

    // return the functional component
    return (
        <div className="homePage">

            {/* Header section */}
            <div className="home-header-container">
                <div className="home-hero-title-wrapper">
                    <div className="head-text home-hero-title">
                        <div>
                            <span className="head-txt-off-white">{t('home.heroTitle1')}</span>
                            <span className="head-txt-primary">{t('home.heroTitle2')}</span>
                            <span className="head-txt-off-white">{t('home.heroTitle3')}</span>
                        </div>
                        <span className="head-txt-primary">{t('home.heroTitle4')}</span>
                    </div>
                </div>
                <div className="home-hero-layout">

                    {/* Left: Phone mockup */}
                    <div className="home-hero-phone">
                        <img src={RokkApp} alt="ROKK App" />
                    </div>

                    {/* Right: Accordion */}
                    <div className="home-hero-accordion">
                        {[
                            {
                                title: t('home.heroAllStyles'),
                                content: <p>{t('home.heroAllStylesDesc')}</p>
                            },
                            {
                                title: t('home.heroFairStreaming'),
                                content: (
                                    <>
                                        <p>{t('home.heroDirectSupport')}</p>
                                        <p>{t('home.heroMorePerStream')}</p>
                                        <a href="/fairness" className="home-hero-more">{t('home.heroMore')}</a>
                                    </>
                                )
                            },
                            {
                                title: t('home.heroAppFeatures'),
                                content: (
                                    <>
                                        <p>{t('home.heroHQAudio')}</p>
                                        <p>{t('home.heroOffline')}</p>
                                        <p>{t('home.heroPlaylistImport')}</p>
                                        <p>{t('home.heroRokkpedia')}</p>
                                        <a href="/rokk" className="home-hero-more">{t('home.heroMore')}</a>
                                    </>
                                )
                            }
                        ].map((item, i) => (
                            <div
                                key={i}
                                className={`hero-accordion-item ${activeCheckpoint === i ? 'hero-accordion-active' : ''}`}
                                onClick={() => switchCheckpoint(i)}
                            >
                                {activeCheckpoint === i && (
                                    <img src={DotElement} className="hero-accordion-dot" alt="" />
                                )}
                                <h2 className="hero-accordion-title">{item.title}</h2>
                                <div className="hero-accordion-content">
                                    <div className="hero-accordion-body">
                                        {item.content}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {/* The Screen containing Promo Video */}

            {/* <div className="screens-bg">
                <img src={ScreensBG} alt="rokk-app-screens" />
                <div className="video-wrapper">
                    <video
                        muted={mute ? true : false}
                        ref={videoRef}
                        loop
                        autoPlay
                        playsInline
                        className="promo-video"
                        onClick={handlePlayback}
                    >
                        <source src={"https://rokk.app/wp-content/uploads/2024/01/ROKK_Campaign_Launch.mp4"} type="video/mp4" />
                        {t('home.videoNotSupported')}
                    </video>
                </div>

                <div className="play-pause-icon-video-playback">
                    {
                        playOption
                            ?
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.playButton')} size="large" onClick={handlePlayback}>
                                <PlayArrow fontSize='medium' />
                            </IconButton>
                            :
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.pauseVideo')} size="large" onClick={handlePlayback}>
                                <Pause fontSize='medium' />
                            </IconButton>

                    }
                </div>

                <div className="mute-unmute-btn">
                    {
                        mute
                            ?
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.playButton')} size="large" onClick={handleSound}>
                                <VolumeOff fontSize='medium' />
                            </IconButton>
                            :
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.pauseVideo')} size="large" onClick={handleSound}>
                                <VolumeUpTwoTone fontSize='medium' />
                            </IconButton>

                    }
                </div>
            </div> */}

            <div className="newsletter-and-card-section flex flex-dir-col">
                <div className="newsletter-container">
                    <div className="newsletter-section-header flex flex-dir-col">
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.subscribeTo')}</span>
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.our')}
                            <span className="head-txt-primary">{t('newsletter.rokk')}</span>
                        </span>
                        <span className="head-txt-primary font-sz-small">{t('newsletter.newsletter')}</span>
                    </div>
                    <NewsletterForm />
                </div>
                <div className="flex jst-con-spc-btw flex-wrap gp-20" style={{ fontFamily: 'var(--title-font)', fontWeight: 'var(--font-main-weight)', paddingRight: '84px' }}>
                    <div className='flex aln-items-cnt gp-10'>
                        <img src={CompactLogo} style={{ width: '25px' }} alt="rokk_logo_compact" />
                        <span className="font-sz-medium">{t('home.whyJoinRokk')}</span>
                    </div>
                    <div className='pricing-section-header'>
                        <span className="head-txt-off-white">{t('home.musicStreamingAppFor')}</span>
                        <span className="head-txt-primary">{t('home.rockAndMetal')}</span>
                    </div>
                </div>
                <div className="newsletter-cards-container">
                    {newsletterCards.map((card, idx) => (
                        <NewsletterCard key={idx} obj={card} />
                    ))}
                </div>
            </div>
            <div className="download-app-container">
                <div className="pricing-section-header" style={{ textAlign: 'center' }}>
                    <span className="head-txt-off-white">{t('home.musicAnytime')}</span>
                    <span className="head-txt-off-white">{t('home.anywhere')}</span>
                </div>

                <div style={{ textAlign: 'center' }}>
                    {t('home.musicStreamingMade')}
                    {t('home.metalAndRockFans')}
                </div>
            </div>
        </div >
    )
}

export default Home
